// extracted by mini-css-extract-plugin
module.exports = {"navBar":"MainMenu_navBar__RIhCw"};